import { BaseProfileFetcher } from './base-profile-fetcher';
import { UserProfile } from '../providers/interfaces/profile-fetcher.interface';

export class MicrosoftProfileFetcher extends BaseProfileFetcher {
  constructor() {
    super('https://graph.microsoft.com/v1.0/me');
  }

  protected mapToUserProfile(rawData: any): UserProfile {
    return {
      email: rawData.mail || rawData.userPrincipalName,
      name: rawData.displayName,
      id: rawData.id,
      avatar: undefined, // Microsoft Graph doesn't include avatar in basic profile
      username: rawData.userPrincipalName,
      raw: rawData,
    };
  }
}
